import axios from '@/axios';

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/saved-searches/`;
const NOTIFICATIONS_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/saved-search-notifications/`;

const rows = payload => payload?.results || payload || [];

const state = {
  searches: [],
  notifications: [],
  loading: false,
  error: null,
};

const mutations = {
  SET_LOADING(state, value) { state.loading = value; },
  SET_ERROR(state, value) { state.error = value; },
  SET_SEARCHES(state, value) { state.searches = rows(value); },
  SET_NOTIFICATIONS(state, value) { state.notifications = rows(value); },
  ADD_SEARCH(state, value) { state.searches.unshift(value); },
  UPDATE_SEARCH(state, value) {
    const index = state.searches.findIndex(item => item.id === value.id);
    if (index !== -1) state.searches.splice(index, 1, { ...state.searches[index], ...value });
  },
  REMOVE_SEARCH(state, id) {
    state.searches = state.searches.filter(item => item.id !== id);
  },
};

const actions = {
  async fetchSearches({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await axios.get(API_BASE);
      commit('SET_SEARCHES', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', 'No pudimos cargar tus alertas.');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchNotifications({ commit }) {
    try {
      const response = await axios.get(NOTIFICATIONS_BASE);
      commit('SET_NOTIFICATIONS', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', 'No pudimos cargar el historial de avisos.');
      throw error;
    }
  },
  async createSearch({ commit }, payload) {
    const response = await axios.post(API_BASE, payload);
    commit('ADD_SEARCH', response.data);
    return response.data;
  },
  async updateSearch({ commit }, { id, payload }) {
    const response = await axios.patch(`${API_BASE}${id}/`, payload);
    commit('UPDATE_SEARCH', response.data);
    return response.data;
  },
  async toggleSearch({ commit }, id) {
    const response = await axios.post(`${API_BASE}${id}/toggle_active/`);
    commit('UPDATE_SEARCH', response.data);
    return response.data;
  },
  async deleteSearch({ commit }, id) {
    await axios.delete(`${API_BASE}${id}/`);
    commit('REMOVE_SEARCH', id);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
